// extracted by mini-css-extract-plugin
export default {"tagList":"styles_tagList__u4S4x","list":"styles_list__m2TC+","showAll":"styles_showAll__nd7Vj"};